import { render } from "./Login.vue?vue&type=template&id=bf774b24"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/web.digitalsystemsrl.it/web.digitalsystemsrl.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__